<apiz-toolbar
  class="iu-apiz-toolbar"
  [filterTplRef]="universalFilter"
  [ngStyle]="{ display: hasUniversalFilter ? '' : 'none' }">
  <div azProjectAs="toolbar-container-left" class="iu-apiz-toolbar-group-left">
    @if (isMobile && isTabTopLevel) {
      <button
        class="p-menu-bar-button"
        data-cy="menuBar-showButtons-btn"
        icon="icon-menu-bars"
        pButton
        tooltipPosition="top"
        type="button"
        [attr.data-cy-toggle-state]="showMoreAction ? 'opened' : 'closed'"
        [hideDelay]="250"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.showButtons' | translate }}"
        [showDelay]="250"
        (click)="onShowMoreAction($event)">
        {{ '' }}
      </button>

      @if (showMoreAction) {
        <ng-container [ngTemplateOutlet]="buttons" />

        <ng-container [ngTemplateOutlet]="viewButtons" />
      }
    } @else if (!isMobile || !isTabTopLevel) {
      <ng-container [ngTemplateOutlet]="buttons" />
    }
  </div>

  <div azProjectAs="toolbar-container-right" class="iu-apiz-toolbar-group-right">
    <iu-favorite-filter [gridView]="gridView" />
    @if (visibleButton && (!isMobile || !isTabTopLevel)) {
      <ng-container [ngTemplateOutlet]="viewButtons" />
    }
  </div>
</apiz-toolbar>

<ng-template #universalFilter>
  <iu-universal-filter-ui [gridView]="gridView" [isMobile]="isMobile" />
</ng-template>

<ng-template #buttons>
  @if (visibleButton) {
    <button
      class="p-menu-bar-button"
      data-cy="button-newRecord"
      icon="icon-add"
      iuKeybinding
      iuKeybinding-code="menu-bar.new"
      pButton
      tooltipPosition="right"
      type="button"
      [disabled]="!newBtnCondition"
      [hideDelay]="250"
      [iuKeybinding-active]="isTabTopLevel && !isSplitView"
      [iuKeybinding-focusTab]="activeTabID"
      [life]="3000"
      pTooltip="{{ tooltipLabels.add }}"
      [showDelay]="250"
      (click)="newEmitter.emit()">
      {{ '' }}
    </button>

    @if (visibleButtonMultiSelection && isDeleteable && (isReadOnly === undefined || isReadOnly === false)) {
      <button
        class="p-menu-bar-button"
        icon="icon-delete"
        iuKeybinding
        iuKeybinding-code="menu-bar.delete"
        pButton
        tooltipPosition="top"
        type="button"
        [hideDelay]="250"
        [iuKeybinding-active]="isTabTopLevel && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ tooltipLabels.delete }}"
        [showDelay]="250"
        (click)="removeEmitter.emit($event)">
        {{ '' }}
      </button>
    }
  }

  <button
    class="p-menu-bar-button"
    data-cy="grid-btn-refresh"
    icon="icon-refresh3x"
    iuKeybinding
    iuKeybinding-code="menu-bar.refresh"
    pButton
    tooltipPosition="top"
    type="button"
    [hideDelay]="250"
    [iuKeybinding-active]="isTabTopLevel && !isSplitView"
    [iuKeybinding-focusTab]="activeTabID"
    [life]="3000"
    pTooltip="{{ tooltipLabels.refresh }}"
    [showDelay]="250"
    (click)="refreshEmitter.emit()">
    {{ '' }}
  </button>
  @if (visibleButton) {
    <button
      class="p-menu-bar-button"
      icon="icon-export"
      iuKeybinding
      iuKeybinding-code="menu-bar.export"
      pButton
      tooltipPosition="top"
      type="button"
      [hideDelay]="250"
      [iuKeybinding-active]="isTabTopLevel && !isSplitView"
      [iuKeybinding-focusTab]="activeTabID"
      [life]="3000"
      pTooltip="{{ tooltipLabels.export }}"
      [showDelay]="250"
      (click)="openExportDataModalEmitter.emit($event)">
      {{ '' }}
    </button>
  }
  @if (visibleButton && visibleButtonMultiSelection && processes().length) {
    <ul class="hover-buttons-list">
      <li>
        <a class="open-icon-title" href="#" (click)="$event.preventDefault()">
          <span>{{ 'menuBarUi.processes' | translate }}</span>
          <i aria-hidden="true" class="icon-next-ancre"></i>
        </a>
        <ul class="hover-buttons">
          @for (process of processes(); track $index) {
            <li>
              <a
                class="hover-button"
                href="#"
                [ngClass]="{ readonly: process.readOnly }"
                (click)="process.readOnly ? null : $event.preventDefault(); showProcessUI(process)">
                <span>{{ process.label }}</span>
                <i aria-hidden="true" class="fas fa-cog"></i>
              </a>
            </li>
          }
        </ul>
      </li>
    </ul>
  }
</ng-template>

<ng-template #viewButtons>
  @if (isTabTopLevel || visibleTreeButton) {
    <button
      class="p-menu-bar-button"
      icon="icon-table"
      iuKeybinding
      iuKeybinding-code="menu-bar.grid-view-type"
      pButton
      tooltipPosition="top"
      type="button"
      [hideDelay]="250"
      [iuKeybinding-active]="isTabTopLevel && !isSplitView"
      [iuKeybinding-focusTab]="activeTabID"
      [life]="3000"
      pTooltip="{{ tooltipLabels.gridView }}"
      [showDelay]="250"
      (click)="switchToGridView()">
      {{ '' }}
    </button>
  }
  @if (isTabTopLevel) {
    <button
      class="p-menu-bar-button"
      icon="icon-kanban"
      iuKeybinding
      iuKeybinding-code="menu-bar.kanban-view-type"
      pButton
      tooltipPosition="top"
      type="button"
      [hideDelay]="250"
      [iuKeybinding-active]="isTabTopLevel && !isSplitView"
      [iuKeybinding-focusTab]="activeTabID"
      [life]="3000"
      pTooltip="{{ tooltipLabels.kanbanView }}"
      [showDelay]="250"
      (click)="switchToKanbanView()">
      {{ '' }}
    </button>
    <button
      class="p-menu-bar-button"
      icon="icon-calendar"
      iuKeybinding
      iuKeybinding-code="menu-bar.calendar-view-type"
      pButton
      tooltipPosition="top"
      type="button"
      [hideDelay]="250"
      [iuKeybinding-active]="isTabTopLevel && !isSplitView"
      [iuKeybinding-focusTab]="activeTabID"
      [life]="3000"
      pTooltip="{{ tooltipLabels.calendarView }}"
      [showDelay]="250"
      (click)="switchToCalendarView()">
      {{ '' }}
    </button>
    <button
      class="p-menu-bar-button"
      icon="icon-graph-smart"
      iuKeybinding
      iuKeybinding-code="menu-bar.chart-view-type"
      pButton
      tooltipPosition="top"
      type="button"
      [hideDelay]="250"
      [iuKeybinding-active]="isTabTopLevel && !isSplitView"
      [iuKeybinding-focusTab]="activeTabID"
      [life]="3000"
      pTooltip="{{ tooltipLabels.chartView }}"
      [showDelay]="250"
      (click)="switchToChartView()">
      {{ '' }}
    </button>
  }
  @if (visibleTreeButton) {
    <button
      class="p-menu-bar-button"
      data-cy="menuBar-tree-view-type-btn"
      icon="icon-tree"
      iuKeybinding
      iuKeybinding-code="menu-bar.tree-view-type"
      pButton
      tooltipPosition="top"
      type="button"
      [hideDelay]="250"
      [iuKeybinding-active]="isTabTopLevel && !isSplitView"
      [iuKeybinding-focusTab]="activeTabID"
      [life]="3000"
      pTooltip="{{ tooltipLabels.treeView }}"
      [showDelay]="250"
      (click)="switchToTreeView()">
      {{ '' }}
    </button>
  }
</ng-template>

<!--
@if (displayProcessUI()) {
  <iu-modal-ui
    [angularStyle]="{ 'iu-modal-body': { padding: 0 } }"
    [contentType]="ModalContentType.PROCESS"
    [hasCloseBtn]="true"
    (closeModalEmitter)="hideProcessUI()">
    <iu-process-ui
      [isModal]="true"
      [parentComponent]="this"
      [windowId]="processId"
      [executeProcess]=""
      (closeModalEmitter)="hideProcessUI()" />
  </iu-modal-ui>
}
-->
